import { render } from "./FormsPage.vue?vue&type=template&id=5cc7d9cd"
import script from "./FormsPage.vue?vue&type=script&lang=js"
export * from "./FormsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__